// extracted by mini-css-extract-plugin
export default {"skeleton":"SectionUserChannelsOngoing_skeleton__RyD94","box":"SectionUserChannelsOngoing_box__KL+Xi"};